import React, { useState, useEffect } from "react";
import axios from "axios";
import { Table } from "reactstrap";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

export default function Adminprojectlist(props) {
  const [projects, setProjects] = useState([]);

  const [projectID, setProjectID] = useState(null);
  const [Title, setTitle] = useState(null);
  const [Language, setLanguage] = useState(null);
  const [Description, setDescription] = useState(null);
  const [Url, setUrl] = useState(null);
  const [From, setFrom] = useState(null);
  const [To, setTo] = useState(null);

  const { className } = props;

  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  useEffect(() => {
    axios
      .get(process.env.REACT_APP_BACKEND_URL + "/api/projects")
      .then(({ data }) => {
        console.log(data);
        setProjects(data);
      })
      .catch((err) => {
        alert(err);
      });
  }, []);

  function OnFormUpdate(e) {
    e.preventDefault();

    if (Title === null) {
      alert("Title is required");
      return false;
    }
    if (Language === null) {
      alert("Language is required");
      return false;
    }
    if (Description === null) {
      alert("Description is required");
      return false;
    }
    if (Url === null) {
      alert("Url is required");
      return false;
    }
    if (From === null) {
      alert("From is required");
      return false;
    }
    if (To === null) {
      alert("To is required");
      return false;
    }

    const newProject = {
      Title,
      Language,
      Description,
      Url,
      From,
      To,
    };

    axios
      .post(
        process.env.REACT_APP_BACKEND_URL + "/api/projects/update/" + projectID,
        newProject
      )
      .then(() => {
        alert("Update Success");
        window.location = "/adminproject";
      })
      .catch((err) => {
        alert(err);
      });
  }

  return (
    <div>
      <div>
        <Modal isOpen={modal} className={className} toggle={toggle}>
          <ModalHeader toggle={toggle}>UPDATE | PROJECTS</ModalHeader>
          <ModalBody>
            <form onSubmit={OnFormUpdate}>
              <div class="form-group">
                <label>Project Title</label>
                <input
                  type="text"
                  class="form-control"
                  value={Title}
                  onChange={(e) => {
                    setTitle(e.target.value);
                  }}
                />
              </div>
              <div class="form-group">
                <label>Language</label>
                <input
                  type="text"
                  class="form-control"
                  value={Language}
                  onChange={(e) => {
                    setLanguage(e.target.value);
                  }}
                />
              </div>
              <div class="form-group">
                <label>Description</label>
                <textarea
                  className="form-control"
                  value={Description}
                  onChange={(e) => {
                    setDescription(e.target.value);
                  }}
                ></textarea>
              </div>
              <div class="form-group">
                <label>URL</label>
                <input
                  type="text"
                  class="form-control"
                  value={Url}
                  onChange={(e) => {
                    setUrl(e.target.value);
                  }}
                />
              </div>
              <div class="form-group">
                <label>From</label>
                <input
                  type="date"
                  class="form-control"
                  value={From}
                  onChange={(e) => {
                    setFrom(e.target.value);
                  }}
                />
              </div>
              <div class="form-group">
                <label>To</label>
                <input
                  type="date"
                  class="form-control"
                  value={To}
                  onChange={(e) => {
                    setTo(e.target.value);
                  }}
                />
              </div>

              <button type="submit" class="btn btn-primary">
                UPDATE
              </button>
            </form>
          </ModalBody>
        </Modal>
      </div>

      <div>
        <Table striped>
          <thead>
            <tr>
              <th scope="col">Title</th>
              <th scope="col">Language</th>
              <th scope="col">Description</th>
              <th scope="col">Url</th>
              <th scope="col">From</th>
              <th scope="col">To</th>
            </tr>
          </thead>
          <tbody>
            {projects.map((project) => {
              return (
                <tr>
                  <td>{project.Title}</td>
                  <td>{project.Language}</td>
                  <td>{project.Description}</td>
                  <td>{project.Url}</td>
                  <td>{project.From.substring(0, 10)}</td>
                  <td>{project.To.substring(0, 10)}</td>
                  <td>
                    <button
                      className="btn btn-primary btn-sm"
                      onClick={() => {
                        axios
                          .get(
                            process.env.REACT_APP_BACKEND_URL +
                              "/api/projects/" +
                              project._id
                          )
                          .then(({ data }) => {
                            console.log(data);
                            setProjectID(data._id);
                            setTitle(data.Title);
                            setLanguage(data.Language);
                            setDescription(data.Description);
                            setUrl(data.Url);
                            setFrom(data.From.substring(0, 10));
                            setTo(data.To.substring(0, 10));
                            setModal(!modal);
                          })
                          .catch((err) => {
                            alert(err);
                          });
                      }}
                    >
                      EDIT
                    </button>
                  </td>
                  <td>
                    <button
                      className="btn btn-danger btn-sm"
                      onClick={() => {
                        axios
                          .delete(
                            process.env.REACT_APP_BACKEND_URL +
                              "/api/projects/remove/" +
                              project._id
                          )
                          .then(() => {
                            alert("Project Deleted");
                            window.location = "/adminproject";
                          })
                          .catch((err) => {
                            console.log(err);
                          });
                      }}
                    >
                      REMOVE
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    </div>
  );
}
